import React from 'react'
import Grid from '@material-ui/core/Grid'
import Paper from '@material-ui/core/Paper'
import Button from '@material-ui/core/Button'
import './EurestoDiv.scss'
import {Fab} from '@material-ui/core'

export default class extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      expanded: props.expanded === false ? false : sessionStorage.getItem(props.id) === "true" || false || !sessionStorage.getItem(props.id) && props.expanded || false
    }
  }

  render () {
    return (
      <Grid container style={{ margin: 0, padding: 5, ...(this.props.mainStyle || {}) }}
            spacing={this.props.spacing || 0} justify="center"
            alignItems="center" wrap={'nowrap'}>
        <Grid item style={{ margin: 0, padding: 0 }} xs={this.props.xs || 12} className={'EurestoDiv'}>
          {((this.props.title !== undefined && this.props.title !== '') || (this.props.buttonsLeft || this.props.elemsLeft || this.props.buttonsRight || this.props.elemsRight)) &&
          <Grid container style={{
            margin: 0,
            cursor: 'default',
            padding: 0,
            width: this.props.fullTitle && 'calc(100% + 2px)' || '100%',
            position: 'relative'
          }} className={'EurestoDivLegend EurestoPrimary--text'}
                spacing={0} direction={'row'} justify={'flex-start'} alignContent={'space-between'}
                alignItems={'center'} wrap={'nowrap'}>


            {this.props.title !== undefined && this.props.title !== '' &&
            <Grid key={'expanded-' + this.state.expanded} item style={{
              ...(this.props.fullTitle && {width: '100%'} || {}),
              maxWidth: !this.props.fullTitle && (this.props.buttonsLeft || this.props.elemsLeft || this.props.buttonsRight || this.props.elemsRight) && '50%' || '100%',
              border: this.props.borderOn !== false && this.props.title && '1px solid ' + EurestoColor('EurestoPrimary'),
              borderRadius: this.props.borderOn !== false && !(!this.props.expandable || this.state.expanded) && 5,
              borderTopRightRadius: 5,
              borderTopLeftRadius: 5,
              borderBottom: this.props.borderOn !== false &&
                (!this.props.expandable || this.state.expanded) && 'none'
                || this.props.borderOn !== false && '1px solid ' + EurestoColor('EurestoPrimary'),
              margin: 0,
              padding: 0,
              left: -1,
              backgroundColor: this.props.backgroundColor || 'white',
              position: 'relative',
              ...(this.props.titleProps && this.props.titleProps.style || {})
            }}>
              <Grid container style={{
                margin: 0,
                padding: 0,
                width: '100%',
              }}
                    spacing={0} direction={'row'}
                    justify={'flex-start'} alignContent={'space-between'} alignItems={'center'} wrap={'nowrap'}>
                {
                  this.props.expandable &&
                  <i style={{ fontSize: 15, paddingLeft: 10 }}
                     onClick={(e) => {
                       e.stopPropagation()
                       sessionStorage.setItem(this.props.id, !this.state.expanded)
                       this.setState({ expanded: !this.state.expanded })
                     }}
                     className={'cursor-pointer ei-commun_carre_' + (this.state.expanded ? 'moins' : 'plus') + ' EurestoSecondary--text'}/>
                }

                <Grid item
                      style={{ margin: 0, padding: '0px 5px', fontWeight: 600, zIndex: 1, textAlign: 'left', width: '100%', ...(this.props.titleStyle || {}) }}>
                  {typeof this.props.title === 'string' && <span
                    onClick={(e) => {
                      if(this.props.expandable) {
                        e.stopPropagation()
                        sessionStorage.setItem(this.props.id, !this.state.expanded)
                        this.setState({ expanded: !this.state.expanded })
                      }
                    }}
                    className={this.props.expandable && "cursor-pointer"}
                    dangerouslySetInnerHTML={{ __html: '<span style="margin: 1px; text-align: left;">' + (this.props.title !== '.' && this.props.title || '') + '</span>' }}/>
                  || this.props.title}
                </Grid>
              </Grid>
            </Grid>}

            {
              (this.state.expanded || !this.props.expandable) && (this.props.buttonsLeft || this.props.elemsLeft || this.props.buttonsRight || this.props.elemsRight)
              &&
              <Grid item xs style={{ margin: 0, padding: 0 }}>
                <Grid container style={{ margin: 0, padding: 0, width: '100%' }} spacing={0} direction={'row'} alignItems={'center'}
                      justify={'flex-end'} wrap={'nowrap'}>
                  {
                    (this.props.buttonsLeft || []).concat((this.props.buttonsRight || [])).map((b, i) => {
                      return b.title &&
                        <Button color={b.color || 'default'} key={i} variant={'contained'}
                                style={Object.assign(i > 0 && { marginLeft: 5 } || {}, b.style || {})} size="small"
                                onClick={(e) => {
                                  e.stopPropagation()
                                  b.cb()
                                }}
                                disabled={b.disabled || false}
                                className={(b.disabled ? 'EurestoDisabled' : ('EurestoPrimary ' + b.className))}>
                          &nbsp;<i
                          className={'fa fa-' + b.icon + ' ' + (b.disabled ? '' : (b.className || 'EurestoSecondary--text'))}/>&nbsp;
                          <span
                            className={(b.disabled ? '' : 'EurestoText--text')}>{b.title}</span>&nbsp;</Button>
                        || <Fab color={b.color || 'default'} key={i} style={i > 0 && { marginLeft: 5 } || {}}
                                size="small"
                                onClick={(e) => {
                                  e.stopPropagation()
                                  b.cb()
                                }}
                                disabled={b.disabled || false}
                                className={(b.disabled ? 'EurestoDisabled' : ('EurestoPrimary ' + b.className))}>
                          <i
                            className={'fa fa-' + b.icon + ' ' + (b.disabled ? '' : (b.className || 'EurestoSecondary--text'))}/><span
                          className={(b.disabled ? '' : 'EurestoText--text')}></span></Fab>
                    })
                  }
                  {
                    (this.props.elemsLeft || []).concat((this.props.elemsRight || [])).map((e) => e)
                  }
                </Grid>
              </Grid>
            }
          </Grid>
          }
          {
            (this.props.expandable && this.state.expanded || this.props.expandable === undefined) &&
            <Paper style={{
              backgroundColor: this.props.backgroundColor || 'white',
              ...(this.props.title !== undefined && this.props.title !== '' && this.props.borderOn !== false && { borderTopLeftRadius: 0, borderTopRightRadius: 0 } || {}),
              ...(this.props.style || {})
            }}>
              <Grid container spacing={0} alignContent={'flex-start'} style={this.props.parentChildrenStyle || {}}>
                {this.props.children}
              </Grid>
            </Paper>
          }
        </Grid>
      </Grid>
    )
  }
}



// WEBPACK FOOTER //
// ./app/Utilitaire/Component/EurestoDiv/index.js